import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuctionService } from '../../services/AuctionService';
import { take } from 'rxjs';
import { BidRequest } from '../../requests/bidRequest';
import { Property } from '../../models/property';
import { BidResponse } from '../../models/bidResult';
import { TransformationService } from '../../services/TransformationService';

@Component({ standalone: false,
  selector: 'place-bid-dialog',
  templateUrl: 'place-bid-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['place-bid-dialog.component.scss']
})
export class PlaceBidDialogComponent {
  title: string= "Confirm Bid";
  confirmButtonText = "Confirm";
  cancelButtonText = "Cancel";

  property!: Property;
  bidAmount!: number;
  directBid :boolean=false;

  busy:boolean=false;
  bidPlacedSuccessfully:boolean=false;
  resultReceived:boolean=false;
  resultCode?:number;
  resultText:string='';
  resultDetails:string='';

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<PlaceBidDialogComponent>, private auctionService:AuctionService, private transformationService:TransformationService) {
    if(data){
      this.property=data.property;
      this.bidAmount=data.bidAmount;
      if(data.directBid) {
        this.directBid=data.directBid;
        this.title="Confirm Direct Bid";
      }
    }
  }

  onConfirmClick(): void {
    //show spinner
    this.busy=true;
    var b = new BidRequest();
    b.auctionId=this.property.auction!.id;
    b.scheduleSeqNo=this.property.auction!.scheduleSeqNo!;
    b.bidAmount=this.bidAmount;
    b.directBid=this.directBid;
    this.auctionService.placeBid(b, this.property).pipe(take(1)).subscribe(r=>this.processBidResult(r));
  }

  onCancelClick(): void {
    this.dialogRef.close(this.bidPlacedSuccessfully);
  }

  get canSubmit(){
    return !this.busy && !this.resultReceived;
  }

  get canCancel(){
    return !this.busy;
  }

  private processBidResult(result:BidResponse){
    this.cancelButtonText="OK";
    this.resultReceived=true;
    this.busy=false;
    switch(result.code){
      case 0:
        //Not authorized
        this.title="Unauthorized"
        this.resultText='You are not authorized to bid on this auction';
        break;
      case 1:
        //Auction ended
        this.title="Bid Rejected"
        this.resultText='Sorry, but the auction just ended';
        break;
      case 2:
        //Bid too low
        this.title="Bid Rejected"
        this.resultText='Sorry, but your bid is too low';
        break;
      case 3:
        //Outbid
        this.bidPlacedSuccessfully=true;
        this.title="Outbid"
        this.resultText=result.bigCode==3?'You were outbid! Another bidder placed a bid for the same amount before you.':'You were outbid';
        break;
      case 4:
        //Highest bidder
        this.bidPlacedSuccessfully=true;
        this.title="Highest Bidder"
        this.resultText='Congratulations! You are the highest bidder.';
        this.resultDetails='Current bid: ' + this.transformationService.transformAmountIfNumber(result.userBid.currentBid,false) + '. Your maximum bid: ' + this.transformationService.transformAmountIfNumber(result.userBid.bidAmount, false);
        break;
      case 5:
         //Increased bid
         this.bidPlacedSuccessfully=true;
         this.title="Bid Increased"
         this.resultText='You increased your bid';
         break;
      case 6:
        //Increased proxy bid
        this.bidPlacedSuccessfully=true;
        this.title="Bid Increased"
        this.resultText='You increased your maximum bid';
        break;
      case 7:
        //Decreased proxy bid
        this.bidPlacedSuccessfully=true;
        this.title="Bid Decreased"
        this.resultText='You decreased your maximum bid';
        break;
      case 8:
        //Cannot lower bid
        this.title="Low Bid"
        this.resultText='You cannot lower your bid';
        break;
      default:
        //Unknown error
        this.title="Error"
        this.resultText='An error occured, try again later';
        break;
    }
  }

}